////////LIBRARY/////////
import { map } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
///////COMPONENTS///////
import { TableBodyWrapper } from '../../../../theme/GlobalCss'
import TableNestedRows from '../TableNestedRows'

const TableNestedBody = ({
	allData,
	editingData,
	columns,
	editing,
	bodyWrapperRef,
	setWidthTable,
	nestedValues,
	tableDataSetter,
	setForceUnsort,
}) => {
	const data = editing ? editingData : allData

	useSelector(
		(state) => ({
			user: state.user,
		}),
		shallowEqual
	)

	const [hasRendered, setHasRendered] = useState(0)
	const [renderTable, setRenderTable] = useState()

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setRenderTable(
			map(data, (row, rowid) => {
				return (
					<TableNestedRows
						key={rowid}
						row={row}
						indexRow={rowid}
						dataSize={data.length}
						id={rowid}
						columns={columns}
						nestedValues={nestedValues}
						tableDataSetter={tableDataSetter}
						setForceUnsort={setForceUnsort}
						dataRef={data}
					/>
				)
			})
		)
		setHasRendered(hasRendered + 1)
	}, [data, columns])

	useEffect(() => {
		// Everytime this var is incremented,
		// Get the size of rows
		if (hasRendered > 0) {
			setWidthTable(bodyWrapperRef.current?.offsetWidth)
		}
	}, [hasRendered])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return <TableBodyWrapper ref={bodyWrapperRef}>{renderTable}</TableBodyWrapper>
}

TableNestedBody.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array,
}
TableNestedBody.defaultPropTypes = {
	columns: [],
	data: [],
}

export default TableNestedBody
